import { CreditReportGuard } from './credit-report.guard';

export const guards: any[] = [CreditReportGuard];

export * from './credit-report.guard';
